import type { ApiResponse, User, UserRole } from '@packages/shared-types';

import { apiClient } from '@/services/apiClient';

export interface CreateInvitationPayload {
  email: string;
  role: UserRole;
  firstName?: string;
  lastName?: string;
}

export async function createInvitation(
  payload: CreateInvitationPayload,
  tenantId?: string | null,
): Promise<User> {
  const params = tenantId ? { tenantId } : {};
  const response = await apiClient.post<ApiResponse<User>>(
    '/api/invitations',
    payload,
    { params },
  );
  return response.data.data;
}

export async function listInvitations(): Promise<User[]> {
  const response = await apiClient.get<ApiResponse<User[]>>('/api/invitations');
  return response.data.data;
}

export async function getInvitationByToken(token: string): Promise<User> {
  const response = await apiClient.get<ApiResponse<User>>(
    `/api/invitations/${token}`,
  );
  return response.data.data;
}
